import PageHeader from '@/components/layout/page-header' // 头部
import nullData from '@/components/nullData/nullData'

export default [
  PageHeader,
  nullData
]
